import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import { genericFetch } from './common-service';
import SfpBaseService from './sfp-base-service';
import * as Model from '../../model'

const SCENARII = 'scenarios';

export default class ScenariiService extends SfpBaseService {

  static findScenariiByLAId(LAId) {
    return fetch(`${apiBaseUrl}/${SCENARII}/la/${LAId}`, {headers: getBaseHeader()})
      .then(super.returnResponse);
  }

  static findCurrentValidatedScenario(LAId) {
    return fetch(`${apiBaseUrl}/${SCENARII}/la/${LAId}/validated`, {headers: getBaseHeader()})
      .then(super.returnResponse);
  }

  static createScenario(scenario) {
    const body = JSON.stringify({scenario});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}`, {body, headers, method: "POST"})
      .then(super.returnResponse);
  }

  static updateScenario(scenario_id, scenario) {
    const body = JSON.stringify({scenario});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario_id}`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
  }

  static duplicateScenario(scenario_id) {
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario_id}/duplicate`, {headers, method: "PUT"})
      .then(super.returnResponse);
  }

  static deleteScenario(scenario_id) {
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario_id}`, {headers, method: "DELETE"})
      .then(super.returnResponse);
  }

	static updateValue(scenario, year, account, amount, percentile, receipts) {
		const body = JSON.stringify({
			year,
			account: account.id,
			amount,
			percentile,
			receipts
    })
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/value`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
	}

	static deleteValue(scenario, year, account, receipts) {
		const body = JSON.stringify({
			year,
			account: account.id,
			receipts
		})
		const headers = {
			...getBaseHeader(),
      'Content-Type': 'application/json'
		}

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/value`, {body, headers, method: "DELETE"})
      .then(super.returnResponse);
	}

	static updatePreviousResult(scenario, year, amount) {
		const body = JSON.stringify({
			year,
			amount,
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/previous_result`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
	}

	static updateChapterValue(scenario, chapter, amount, receipts) {
		const body = JSON.stringify({
			chapter: chapter.id,
			amount,
			receipts
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/chapter/value`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
	}

	static deleteChapterValue(scenario, chapter, receipts) {
		const body = JSON.stringify({
			chapter: chapter.id,
			receipts
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/chapter/value`, {body, headers, method: "DELETE"})
      .then(super.returnResponse);
	}

	static updateAccountValue(scenario, account, amount, receipts) {
		const body = JSON.stringify({
			account: account.id,
			amount,
			receipts
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/account/value`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
	}

	static deleteAccountValue(scenario, account, receipts) {
		const body = JSON.stringify({
			account: account.id,
			receipts
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/account/value`, {body, headers, method: "DELETE"})
      .then(super.returnResponse);
	}

	static updateAccountThemeValue(scenario, account, theme, amount, receipts) {
		const body = JSON.stringify({
			account: account.id,
			theme: `${theme.localAuthority}|${theme.slug}`,
			amount,
			receipts
    })
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/account/theme/value`, {body, headers, method: "PUT"})
      .then(super.returnResponse);

  }
  
  static updateArbitrageThemeValue(scenario, account, theme, amount, receipts) {
		const body = JSON.stringify({
			account: account.id,
			theme: `${theme.localAuthority}|${theme.slug}`,
			amount,
			receipts
    })
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/account/theme/arbitrage/value`, {body, headers, method: "PUT"})
      .then(super.returnResponse);

  }

  static updateArbitrageThemeValueCopy(scenario) {
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/accounts/copy/arbitrage-to-scenario`, {headers, method: "PUT"})
      .then(super.returnResponse);

  }

	static updateAccountsThemeValue(scenario, accountIds, theme, amount, receipts) {
		const body = JSON.stringify({
			accounts: accountIds,
			theme: `${theme.localAuthority}|${theme.slug}`,
			amount,
			receipts
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/accounts/theme/value`, {body, headers, method: "PUT"})
      .then(super.returnResponse);

  }
  
  static updateArbitragesThemeValue(scenario, accountIds, theme, amount, receipts) {
		const body = JSON.stringify({
			accounts: accountIds,
			theme: `${theme.localAuthority}|${theme.slug}`,
			amount,
			receipts
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/accounts/theme/arbitrage/value`, {body, headers, method: "PUT"})
      .then(super.returnResponse);

  }
  

	static deleteAccountTheme(scenario, account, theme) {
		const body = JSON.stringify({
			account: account.id,
			theme: `${theme.localAuthority}|${theme.slug}`
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/account/theme/value`, {body, headers, method: "DELETE"})
      .then(super.returnResponse);
	}

	static deleteAccountsTheme(scenario, accountIds, theme) {
		const body = JSON.stringify({
			accounts: accountIds,
			theme: `${theme.localAuthority}|${theme.slug}`
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/accounts/theme/value`, {body, headers, method: "DELETE"})
      .then(super.returnResponse);
	}

	static validTheme(scenario, theme, valid) {
		const body = JSON.stringify({
			theme: `${theme.localAuthority}|${theme.slug}`,
			valid
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/valid/theme`, {body, headers, method: "PUT"})
      .then(super.returnResponse);

  }
  
	static validThemearbitrage(scenario, theme, valid) {
		const body = JSON.stringify({
			theme: `${theme.localAuthority}|${theme.slug}`,
			valid
		})
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/valid/theme`, {body, headers, method: "PUT"})
      .then(super.returnResponse);

  }
  

  /**
   * @typedef {Object} DataRow
   * @property {Model.Account} account
   * @property {number} receipts
   * @property {number} expenses
   */

  /**
   * @param {Model.Scenario} scenario
   * @param {DataRow[]} data
   * @returns {Promise<Model.Observation[]>}
   */
	static updateRetro(scenario, data) {
		const body = JSON.stringify({ data })
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };
    return genericFetch(`${apiBaseUrl}/${SCENARII}/${scenario.id}/update_retro`, {body, headers, method: "PUT"})
	}

}



// WEBPACK FOOTER //
// ./src/service/sfp/scenario-service.js